import type { SVGProps } from 'react';
const SvgHighlightAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#highlight_alt_svg__a)">
      <path
        fill="currentColor"
        d="M17 5h-2V3h2v2Zm-2 16h2v-2.59L19.59 21 21 19.59 18.41 17H21v-2h-6v6Zm4-12h2V7h-2v2Zm0 4h2v-2h-2v2Zm-8 8h2v-2h-2v2ZM7 5h2V3H7v2ZM3 17h2v-2H3v2Zm2 4v-2H3c0 1.1.9 2 2 2ZM19 3v2h2c0-1.1-.9-2-2-2Zm-8 2h2V3h-2v2ZM3 9h2V7H3v2Zm4 12h2v-2H7v2Zm-4-8h2v-2H3v2Zm0-8h2V3c-1.1 0-2 .9-2 2Z"
      />
    </g>
    <defs>
      <clipPath id="highlight_alt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHighlightAlt;
